var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
var COL = {
  1: "".concat(100 / 12, "%"),
  2: "".concat(100 / 6, "%"),
  3: "".concat(100 / 4, "%"),
  4: "".concat(100 / 3, "%"),
  5: "".concat(100 / 12 * 5, "%"),
  6: "".concat(100 / 2, "%"),
  7: "".concat(100 / 12 * 7, "%"),
  8: "".concat(100 / 12 * 8, "%"),
  9: "".concat(100 / 12 * 9, "%"),
  10: "".concat(100 / 12 * 10, "%"),
  11: "".concat(100 / 12 * 11, "%"),
  12: '100%'
};
var GridColumn = /*#__PURE__*/styled.div.withConfig({
  displayName: "GridColumn",
  componentId: "sc-1yc67ea-0"
})(["padding:0 ", ";margin:", ";width:", ";box-sizing:border-box;", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spacing.sp8;
}, function (_ref2) {
  var noMargin = _ref2.noMargin,
    theme = _ref2.theme;
  return noMargin ? '0' : "0 0 ".concat(theme.spacing.sp32);
}, function (_ref3) {
  var mobile = _ref3.mobile;
  return mobile ? COL[mobile] : COL[12];
}, function (_ref4) {
  var order = _ref4.order;
  return order && "order: ".concat(order);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.tabletPortrait(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n"])), function (_ref6) {
    var tablet = _ref6.tablet;
    return tablet && "width: ".concat(COL[tablet]);
  });
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.tabletLandscape(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n"])), function (_ref8) {
    var desktop = _ref8.desktop;
    return desktop && "width: ".concat(COL[desktop]);
  });
});
GridColumn.displayName = 'GridColumn';
export default GridColumn;